// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  width: 100%;
  height: 100vh;
  background-image: url('banner.png');
  background-size: cover;
  background-position: center;
}

.navbar-nav {
  width: 100%;
  justify-content: flex-end;
}

nav {
  position: absolute;
  width: 100%;
}

.info-banner {
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 90%;
  margin: 0 auto;
}

.green-btm {
  border-bottom: 8px solid #24AB73;
}

.btn-landing {
  background-color: #24AB73;
  border-radius: 54px;
  width: 160px;
  height: 35px;
  text-align: center;
  color: white !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-bigger {
  transform: scale(1.3);
  margin: 0 0 0 25px;
}

.title-landing {
  font-size: 4rem;
}

.info-txt {
  font-size: 1.5rem;
}

.banner2 {
  background-color: #E7F9F5;
  width: 100%;
  min-height: 165px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
}

.mini-card {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mini-card .img-mini {
  width: 80%;
}
.mini-card .mini-text {
  width: 50%;
  text-align: center;
}

.phone1 {
  margin-top: -70px;
}

.phone2 {
  margin-top: 95px;
}

footer {
  width: 100%;
  height: 180px;
  margin-top: -180px;
  background-image: url('footer.png');
}`, "",{"version":3,"sources":["webpack://./src/app/landing/landing.component.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,aAAA;EACA,mCAAA;EACA,sBAAA;EACA,2BAAA;AADJ;;AAIA;EACI,WAAA;EACA,yBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,WAAA;AADJ;;AAIA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;AADJ;;AAIA;EACI,gCAAA;AADJ;;AAIA;EACI,yBAlCc;EAmCd,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,qBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AADJ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAKI;EACI,UAAA;AAHR;AAMI;EACI,UAAA;EACA,kBAAA;AAJR;;AAQA;EACI,iBAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;AALJ","sourcesContent":["$primary-landing: #24AB73;\r\n\r\n.banner{\r\n    width: 100%;\r\n    height: 100vh;\r\n    background-image: url(\"../../assets/img/banner.png\");\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n\r\n.navbar-nav{\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n}\r\n\r\nnav{\r\n    position: absolute;\r\n    width: 100%;\r\n}\r\n\r\n.info-banner{\r\n    height: 100%;\r\n    display: flex;\r\n    flex-flow: column;\r\n    justify-content: center;\r\n    width: 90%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.green-btm{\r\n    border-bottom: 8px solid $primary-landing;\r\n}\r\n\r\n.btn-landing{\r\n    background-color: $primary-landing;\r\n    border-radius: 54px;\r\n    width: 160px;\r\n    height: 35px;\r\n    text-align: center;\r\n    color: white !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.btn-bigger{\r\n    transform: scale(1.3);\r\n    margin: 0 0 0 25px;\r\n}\r\n\r\n.title-landing{\r\n    font-size: 4rem;\r\n}\r\n\r\n.info-txt{\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.banner2{\r\n    background-color: #E7F9F5;\r\n    width: 100%;\r\n    min-height: 165px;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n\r\n}\r\n\r\n\r\n.mini-card{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    .img-mini{\r\n        width: 80%;\r\n    }\r\n\r\n    .mini-text{\r\n        width: 50%;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.phone1{\r\n    margin-top: -70px;\r\n}\r\n\r\n.phone2{\r\n    margin-top: 95px;\r\n}\r\n\r\nfooter{\r\n    width: 100%;\r\n    height: 180px;\r\n    margin-top: -180px;\r\n    background-image: url(\"../../assets/img/footer.png\");\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
